<template>
<div >
  <v-card flat xs12 full-width >
    <v-card-title
      v-if='withTitle && window === 0 && appointmentIds'
      class='subheading' >
      {{ $tc('messages.selectedappointments', appointmentIds.length, {n: appointmentIds.length}) }}
      <v-spacer></v-spacer>
    </v-card-title>
    <v-card-text>
      <v-window v-model="window" vertical touchless >
        <v-window-item :key='0' >
          <template v-if='codes.length > 0' >
            <v-list class='mb-0' >
              <template v-for='(code, index) in codes'>
                <v-list-tile :key='code.key' >
                  <v-list-tile-avatar v-if='code.currency' >
                    {{ formatCurrency(code.currency, code.price) }}
                  </v-list-tile-avatar>
                  <v-list-tile-content class='pl-2'>
                    <v-list-tile-title >
                      {{code.icd10}}
                    </v-list-tile-title>
                    <v-list-tile-sub-title>
                      {{code.process}}
                    </v-list-tile-sub-title>
                  </v-list-tile-content>
                  <v-list-tile-action>
                    <v-btn @click='del(index)' icon><v-icon>delete</v-icon></v-btn>
                  </v-list-tile-action>
                </v-list-tile>
                <v-divider inset :key='`d-${index}`' ></v-divider>
              </template>
            </v-list>

            <v-card-actions >
              <v-spacer ></v-spacer>
              <v-btn
                  @click='save'
                  :loading='loading'
                  :disabled='appointmentIds.length === 0 || codes.length === 0'
                  class="primary" >
                  Save codes</v-btn>
            </v-card-actions>
          </template>
          <v-divider></v-divider>
          <v-form v-model="valid" class='grey lighten-4'>
            <v-layout row wrap >
              <v-flex xs12 sm4
                v-for='field in fields'
                :key='field.label' >
                <v-text-field
                  :solo='!$vuetify.breakpoint.xs'
                  @keypress.enter='add'
                  class='mx-1 mt-1 pb-0'
                  v-model='code[field.key]'
                  v-bind='field' >
                </v-text-field>
              </v-flex>
            </v-layout>
            <v-layout>
              <v-spacer></v-spacer>
              <v-btn
                @click='add'
                :loading='loading'
                :disabled='!valid'
                small flat >
                <v-icon>add</v-icon>
                Add code</v-btn>
            </v-layout>
          </v-form>
        </v-window-item>

        <v-window-item :key='1' >
          <v-card style='width:100%;' >
            <v-card-text class='text-xs-center'>
              <v-icon large color='green' >check_circle</v-icon>
              <p class='mt-4 blockquote'>Codes have been added</p>
              <!-- to {{appointmentIds.length}} appointment/s</p> -->
              <v-btn @click='window = 0' flat small >Add more</v-btn>
            </v-card-text>
            <v-card-actions v-if='withDone' >
              <v-spacer></v-spacer>
              <v-btn @click='$emit("close")' >Done</v-btn>
            </v-card-actions>
          </v-card>
        </v-window-item>
      </v-window>
    </v-card-text>
  </v-card>
  <!-- code picker dialogs -->
  <v-dialog v-model="processcodepicker" :fullscreen='$vuetify.breakpoint.xsOnly' >
    <v-system-bar :color='themeColor' class='visible-ios-only main' ></v-system-bar>
    <v-toolbar dark dense short :color='themeColor' >
      <v-toolbar-title >{{ $t('dialogs.titles.processpicker') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click='processcodepicker=false' ><v-icon>close</v-icon></v-btn>
    </v-toolbar>
    <v-card flat>
      <process-code-picker
        v-model='code.process'
        :initial-search-string='processSearchString'
        @input='setProcessCode' ></process-code-picker>

      <v-card-actions >
        <v-spacer></v-spacer>
        <v-btn @click='processcodepicker=false' flat >Done</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog
    v-model="ICD10codepicker"
    :fullscreen='$vuetify.breakpoint.xsOnly' >
    <v-system-bar :color='themeColor' class='visible-ios-only main' ></v-system-bar>
    <v-toolbar dark dense short :color='themeColor' >
      <v-toolbar-title >{{ $t('dialogs.titles.icd10picker') }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click='ICD10codepicker=false' ><v-icon>close</v-icon></v-btn>
    </v-toolbar>
    <v-card flat>
      <icd-picker
        @input='setIcdCode'
        :touch='icdtouch'
        :initial-search-string='codeSearchString' >
      </icd-picker>
      <v-card-actions >
        <v-spacer></v-spacer>
        <v-btn @click='ICD10codepicker=false' flat >Done</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

</div>
</template>

<script>
import vue from 'vue'
import axios from 'axios'

import IcdPicker from '@/components/pickers/IcdPicker'
import ProcessCodePicker from '@/components/pickers/ProcessCodePicker'

export default {
  name: 'BulkAddCodes',
  components: {IcdPicker, ProcessCodePicker},
  props: {
    appointmentIds: { type: Array, default: () => { return [] } },
    touch: { type: Number, default: 10 },
    withDone: { type: Boolean, default: false },
    withTitle: { type: Boolean, default: false }
  },
  data () {
    return {
      window: 0,
      loading: false,
      valid: false,
      done: false,
      code: {
        'currency': 'ZAR',
        'icd10': null,
        'process': null,
        'price': null
      },
      icdtouch: 1,
      processcodepicker: false,
      processSearchString: '',
      codeSearchString: '',
      ICD10codepicker: false,
      codes: [],
      fields: [
        {
          label: 'ICD10 code',
          key: 'icd10',
          rules: [
            v => !!v || 'ICD10 code is required'
          ],
          appendIcon: 'search',
          appendIconCb: () => (this.showICDPicker())
        },
        {
          label: 'Process code',
          key: 'process',
          rules: [
            v => !!v || 'process code is required'
          ],
          appendIcon: 'search',
          appendIconCb: () => (this.showProcessPicker())
        },
        {
          label: 'Price',
          key: 'price',
          type: 'number',
          rules: [
            v => !!v || 'price is required'
          ]
        }
      ]
    }
  },
  computed: {
    payload () {
      return {
        codes: this.codes
      }
    },
    codeCount () {
      return this.codes.length
    }
  },
  watch: {
    touch () {
      this.window = 0
    },
    ICD10codepicker () {
      if (this.ICD10codepicker) { // only reset when they open the dialog
        this.icdtouch = Math.random()
      }
    }
  },
  methods: {
    add () {
      let copy = JSON.parse(JSON.stringify(this.code))
      this.codes.push(copy)
      vue.set(this.code, 'process', null)
    },
    save () {
      let vm = this
      let ids = this.appointmentIds.join(',')
      let url = `${this.$appointmentguru.baseUrl}/api/appointments/bulk/${ids}/codes/`
      let options = {
        headers: this.$appointmentguru.headers
      }
      vm.loading = true
      axios.post(url, this.payload, options)
        .then((res) => {
          vm.$emit('saved', res.data)
          vm.codes = []
          vm.window = 1
        })
        .catch(() => {
        })
        .then(() => {
          vm.loading = false
        })
    },
    del (index) {
      this.codes.splice(index, 1)
    },
    showICDPicker () {
      this.ICD10codepicker = true
      this.codeSearchString = this.code.icd10
    },
    setIcdCode (code) {
      this.code.icd10 = code.name
      this.ICD10codepicker = false
    },
    showProcessPicker () {
      this.processcodepicker = true
      this.processSearchString = this.code.process
    },
    setProcessCode (code) {
      this.code.process = code.name
      if (code.discovery_rate) {
        this.code.price = code.discovery_rate
      }
      if (code.price) {
        this.code.price = code.price
      }
      this.processcodepicker = false
    }
  },
  i18n: {
    messages: {
      en: {
        messages: {
          selectedappointments: '{n} selected appointments | {n} selected appointment | {n} selected appointments'
        },
        dialogs: {
          titles: {
            icd10picker: 'Find a code',
            processpicker: 'Find a code'
          }
        }
      }
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// BulkAddCodes.vue?7995dfce